import { toSearchText } from "@/core/helpers/routeSearch";
import { ConsignmentStockLedgerListPage } from "@/features/consignment-stock-ledger/pages/ConsignmentStockLedgerListPage";
import { createFileRoute } from "@tanstack/react-router";

type ConsignmentStockLedgerSearch = {
	produk?: string;
	toko?: string;
};

export const Route = createFileRoute("/vendor/consignment-stock-ledger/")({
	validateSearch: (
		search: Record<string, unknown>,
	): ConsignmentStockLedgerSearch => ({
		produk: toSearchText(search.produk),
		toko: toSearchText(search.toko),
	}),
	component: ConsignmentStockLedgerListPage,
});
